import { Box, Typography } from "@mui/material";
import { useSingleUserControl } from "../../../context/SuperAdmin/SingleUserControlContext";
import EstadoBadge from "./EstadoBadge";
import { formatFechaWithHour } from "../../../utils/dateFunctions";

const RDSView = () => {
  const { rdsUser } = useSingleUserControl();

  const estadoMap: Record<string, "success" | "warning" | "wrong" | "unknown"> =
    {
      Activo: "success",
      Inactivo: "warning",
      Eliminado: "wrong",
    };

  if (!rdsUser) return null;

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: 2,
        pt: 2,
        fontSize: "14px",
      }}
    >
      {/* ID */}
      <Box>
        <Typography fontWeight="bold">ID</Typography>
        <Typography>{rdsUser.id_usuario}</Typography>
      </Box>

      {/* Nombre completo */}
      <Box>
        <Typography fontWeight="bold">Nombre completo</Typography>
        <Typography>
          {`${rdsUser.nombres} ${rdsUser.apellidos || ""}`.trim()}
        </Typography>
      </Box>

      {/* Email */}
      <Box>
        <Typography fontWeight="bold">Email</Typography>
        <Typography>{rdsUser.email}</Typography>
      </Box>

      {/* País */}
      <Box>
        <Typography fontWeight="bold">País</Typography>
        <Typography>{rdsUser.pais}</Typography>
      </Box>

      {/* Versión */}
      <Box>
        <Typography fontWeight="bold">Versión</Typography>
        <Typography>{rdsUser.version}</Typography>
      </Box>

      {/* Estado */}
      <Box>
        <Typography fontWeight="bold">Estado</Typography>
        <EstadoBadge estado={estadoMap[rdsUser.estado] ?? "unknown"}>
          {rdsUser.estado}
        </EstadoBadge>
      </Box>

      {/* Fecha de creación */}
      <Box>
        <Typography fontWeight="bold">Fecha de creación</Typography>
        <Typography>{formatFechaWithHour(rdsUser.created_at)}</Typography>
      </Box>

      {/* Última actualización */}
      <Box>
        <Typography fontWeight="bold">Última actualización</Typography>
        <Typography>{formatFechaWithHour(rdsUser.updated_at)}</Typography>
      </Box>
    </Box>
  );
};

export default RDSView;
